// extracted by mini-css-extract-plugin
export var gif = "_jn-0";